import { render, staticRenderFns } from "./MyContact.vue?vue&type=template&id=5ea7bd2a&"
import script from "./MyContact.vue?vue&type=script&lang=js&"
export * from "./MyContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports